import { render, staticRenderFns } from "./UnauthorizedComponent.vue?vue&type=template&id=61caefd5"
import script from "./UnauthorizedComponent.vue?vue&type=script&lang=js"
export * from "./UnauthorizedComponent.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedComponent.vue?vue&type=style&index=0&id=61caefd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports